import React from 'react'

import View from '../../../components/pdf/View'
import { useServiceOrder } from './_load/ServiceOrderLoader'
import { Table, TableRow } from '../../../components/pdf/Table'
import { TableColText } from '../../../components/pdf/TableHelpers'
import {
  SERVICE_DESCRIPTION_REPLY_ID,
  UNIT_REPLY_ID,
  findReplyByQuestionId,
  getReplyValue,
  useGroupReplies
} from './_helpers/pdfHelpers'
import { useChildrenServiceOrders } from './_load/ChildrenServiceOrderLoader'
import { concat } from 'ramda'
import { COLORS } from '@btime/constants'
import Image from '../../../components/pdf/Image'
import moment from 'moment'

const SERVICE_HEADER_STYLE = { verticalAlign: 'middle', backgroundColor: '#D9D9D9' }
const SERVICE_HEADER_PROPS = { align: 'center', color: COLORS.black, width: '26px', bold: true }
const SERVICE_COL_PROPS = { color: COLORS.black, align: 'center' }
const DOCUMENT_HEADER_PROPS = { color: COLORS.black, colSpan: 2, align: 'left' }

const BmTable = () => {
  const groupReplies = useGroupReplies()
  const serviceOrder = useServiceOrder()
  const childrenServiceOrder = useChildrenServiceOrders()
  const serviceOrderGroupedReplies = groupReplies(serviceOrder?.replies)

  const childrenGroupedReplies = childrenServiceOrder?.flatMap(item => {
    return groupReplies(item.replies)
  })

  const allReplies = concat(serviceOrderGroupedReplies, childrenGroupedReplies)

  let totalHours = 0
  let totalValue = 0

  return (
    <View pageBreakAfter>
      <Table width="100%" color={COLORS.black}>
        <TableRow key={'title'} color={COLORS.black}>
          <TableColText
            color={COLORS.black}
            colSpan={6}
            bold
            size={19}
            align={'center'}
            style={{ paddingTop: '10px', paddingBottom: '10px' }}
          >
            BOLETIM DE MEDIÇÃO
          </TableColText>
          <TableColText
            color={COLORS.black}
            rowSpan={3}
            colSpan={3}
            align={'center'}
            style={{ align: 'center', padding: '10px' }}
          >
            <Image src="/pdfs/manserv/logo_basf.png" />
          </TableColText>
        </TableRow>

        <TableRow key={'header-1'} color={COLORS.black}>
          <TableColText {...DOCUMENT_HEADER_PROPS} bold>
            DATA: {moment().format('DD/MM/YYYY')}
          </TableColText>
          <TableColText {...DOCUMENT_HEADER_PROPS}>
            <span style={{ fontWeight: '900' }}>FORNECEDOR:</span> MANSERV MONTAGEM E MANUTENÇÃO S/A
          </TableColText>
          <TableColText {...DOCUMENT_HEADER_PROPS}>
            <span style={{ fontWeight: '900' }}>EMAIL:</span> diorgison.ferreira@manserv.com.br;
            denize.vasquez@manserv.com.br
          </TableColText>
        </TableRow>

        <TableRow key={'header-2'} color={COLORS.black}>
          <TableColText {...DOCUMENT_HEADER_PROPS}>
            <span style={{ fontWeight: '900' }}>LOCAL BASF:</span> GUARATINGUETÁ
          </TableColText>
          <TableColText {...DOCUMENT_HEADER_PROPS}>
            <span style={{ fontWeight: '900' }}>CÓDIGO SAP:</span> 3159147
          </TableColText>
          <TableColText {...DOCUMENT_HEADER_PROPS}>
            <span style={{ fontWeight: '900' }}>CNPJ:</span> 54.183.587/0002-21
          </TableColText>
        </TableRow>

        <TableRow key={'separator-1'} color={COLORS.black}>
          <TableColText color={COLORS.black} style={{ height: '15px' }}></TableColText>
        </TableRow>

        <TableRow key={'boletim-header'} color={COLORS.black}>
          <TableColText {...DOCUMENT_HEADER_PROPS} colSpan={6} style={{ paddingTop: '10px', paddingBottom: '10px' }}>
            <span style={{ fontWeight: '900' }}>Nº DO BOLETIM MEDIÇÃO:</span> {serviceOrder.yearlyId} EQUIPE VARIÁVEL -
            FFP
          </TableColText>
        </TableRow>
        <TableRow key={'separator-2'} color={COLORS.black}>
          <TableColText color={COLORS.black} style={{ height: '15px' }}></TableColText>
        </TableRow>
        <TableColText style={SERVICE_HEADER_STYLE} {...SERVICE_HEADER_PROPS}>
          ITEM
        </TableColText>
        <TableColText style={SERVICE_HEADER_STYLE} {...SERVICE_HEADER_PROPS}>
          PRÉDIO
        </TableColText>
        <TableColText style={SERVICE_HEADER_STYLE} {...SERVICE_HEADER_PROPS} width={'100px'}>
          CÓDIGO SERVIÇO
        </TableColText>
        <TableColText style={SERVICE_HEADER_STYLE} {...SERVICE_HEADER_PROPS} width={'180px'}>
          DESCRIÇÃO DO CODIGO DE SERVIÇO
        </TableColText>
        <TableColText style={SERVICE_HEADER_STYLE} {...SERVICE_HEADER_PROPS}>
          QUANTIDADE
        </TableColText>
        <TableColText style={SERVICE_HEADER_STYLE} {...SERVICE_HEADER_PROPS}>
          UNIT. (R$)
        </TableColText>
        <TableColText style={SERVICE_HEADER_STYLE} {...SERVICE_HEADER_PROPS}>
          HORAS
        </TableColText>
        <TableColText style={SERVICE_HEADER_STYLE} {...SERVICE_HEADER_PROPS}>
          TOTAL (R$)
        </TableColText>
        {allReplies?.map((replies, index) => {
          const building = getReplyValue(findReplyByQuestionId(replies, 137))
          const serviceCode = getReplyValue(findReplyByQuestionId(replies, 149))
          const serviceDescription = getReplyValue(findReplyByQuestionId(replies, SERVICE_DESCRIPTION_REPLY_ID))
          const unit = getReplyValue(findReplyByQuestionId(replies, UNIT_REPLY_ID))
          const amount = getReplyValue(findReplyByQuestionId(replies, 162))

          const total = amount * unit
          totalHours += amount
          totalValue += total
          return (
            <TableRow key={index} color={COLORS.black}>
              <TableColText {...SERVICE_COL_PROPS}>{index + 1}</TableColText>
              <TableColText bold align={'center'} {...SERVICE_COL_PROPS}>
                {building}
              </TableColText>
              <TableColText {...SERVICE_COL_PROPS}>{serviceCode}</TableColText>
              <TableColText {...SERVICE_COL_PROPS} align={'left'}>
                {serviceDescription}
              </TableColText>
              <TableColText {...SERVICE_COL_PROPS}>{amount}</TableColText>
              <TableColText {...SERVICE_COL_PROPS}>{`R$ ${unit}`}</TableColText>
              <TableColText {...SERVICE_COL_PROPS}>{amount}</TableColText>
              <TableColText {...SERVICE_COL_PROPS} align={'center'}>{`R$ ${total.toFixed(2)}`}</TableColText>
            </TableRow>
          )
        })}
        <TableRow key={'total'} color={COLORS.black}>
          <TableColText color={COLORS.black} bold align={'right'} colSpan={6}>
            TOTAL DO BOLETIM
          </TableColText>
          <TableColText color={COLORS.black} bold align={'center'}>
            {totalHours}
          </TableColText>
          <TableColText color={COLORS.black} bold align={'center'}>
            {`R$ ${totalValue.toFixed(2)}`}
          </TableColText>
        </TableRow>
        <TableRow key={'separator-3'} color={COLORS.black}>
          <TableColText color={COLORS.black} style={{ height: '15px' }}></TableColText>
        </TableRow>
        <TableRow key={'separator-4'} color={COLORS.black}>
          <TableColText color={COLORS.black} size={10} bold style={{ height: '40px' }}>
            {'Data:'}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;/
          </TableColText>
        </TableRow>
        <TableRow key={'manager-sign'} color={COLORS.black}>
          <TableColText colSpan={6} color={COLORS.black} style={{ height: '90px' }}>
            ASSINATURA GESTOR BASF:
          </TableColText>
        </TableRow>
        <TableRow key={'disclaimer'} color={COLORS.black}>
          <TableColText colSpan={6} color={COLORS.black} size={10} bold>
            O fornecedor só poderá emitir nota fiscal após emissão da folha de serviço.
          </TableColText>
        </TableRow>
      </Table>
    </View>
  )
}

export default BmTable
